import React  , { Component } from 'react'
import LazyLoad from 'react-lazyload';
import { animateScroll as scroll } from 'react-scroll'
import {  HomeSlider,
          HomeDeals,
          VideoSliderItem,
          PostSliderItem,
          HomeTitle,
          ResponsiveYouTubeIframe,
          ImgAndText,
          CoverSection   } from '../../Components/UI/UI'

import {  newPosts } from "../../Data/Data";
import { getWeather , foundInString, getUrl, asyncgetWeather } from "../../Utility/Utility";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'
import SimpleSlider from '../../Components/SimpleSlider/SimpleSlider';
import "../innerPage.css"
import "./WhereToGo.css"

// private class data 

 const PageObj1 = {
    img : 'wtg1.jpg' ,
    img_mob : 'wtg1-mob.jpg' ,
    link : '/Pages/TelAvivPage',
    text : 'تل-أبيب يافا'
  }

  const PageObj2 = {
    img : 'wtg2.jpg' ,
    img_mob : 'wtg2-mob.jpg' ,
    link : '/Pages/JerusalemPage',
    text : 'القدس'
  }

  const PageObj3 = {
    img : 'wtg3.jpg' ,
    img_mob : 'wtg3.jpg' ,
    link : '/Pages/DeadSeaPage',
    text : 'البحر الميّت'
  }

  const PageObj4 = {
    img : 'wtg5.jpg' ,
    img_mob : 'wtg5.jpg' ,
    link : '/Pages/NorthPage',
    text : 'زوروا منطقة الجليل'
  }

  const PageObj5 = {
    img : 'wtg4.jpg' ,
    img_mob : 'wtg4.jpg' ,
    link : '/Pages/EilatNegevPage',
    text : 'زوروا النقب وإيلات'
  }
  const PageObj6 = {
    img_mob : 'wtg6-mob.jpg' ,
    link : '/Pages/thingsToDo',
    text : 'نشاطات ننصح بها'
  }


class WhereToGo extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

    telAvivVideo: "XDei1Zy_cu4",
    telAvivVideoState : 0,
    jerusalemVideo : "k4OwoEk5wMw",
    jerusalemVideoState:0,
    deadSeaVideo : "DzEJxjnC_UQ",
    deadSeaVideoState:0,


  }

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
        var weather = response[0];
     

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                        
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}
 


   


  render(){
     
    
   return(


      <div className="inner-page align-center page-whereToGo">
        <Menu />
        <div className="relative">
          {/*<HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />*/}
         <CoverSection desktopImg={'/posts/bank/page-wheretogo/1.jpg'} mobileImg={'/posts/bank/page-wheretogo/M.jpg'} cssClass={'jerusalim'} waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather}/>
        </div>
      
          <section  className="home-section home-section-padding weather-section" id="expore-tel-aviv">
            <div className="container ac-flex ac-flex-column">
               <HomeTitle>
                لا تفوّتوا زيارة هذه الأماكن
                </HomeTitle>
              <div class="ac-row ac-flex ac-flex-row ac-flex-row-mob">
                <div className="ac-inner-50 ac-margin-right">
                 <ImgAndText img={PageObj1.img}  img_mob={PageObj1.img_mob} cssClass={" col-100"} link={PageObj1.link} text={PageObj1.text} />
                  <a class="show_more button" target="_self" href={ getUrl() + 'Pages/TelAvivPage'}>
                     اقرأوا المزيد >>
                  </a>
                </div>
                <div className="ac-inner-50">
                 <ImgAndText img={PageObj2.img} img_mob={PageObj2.img_mob} cssClass={" col-100"} link={PageObj2.link} text={PageObj2.text} />
                 <a class="show_more button" href={ getUrl() + 'Pages/JerusalemPage'}>
                    اقرأوا المزيد >>
                  </a>
                </div>
              </div>
              <div class="ac-row ac-flex ac-flex-row ac-flex-row-mob">
              <div className="ac-inner-33 ">
               <ImgAndText img={PageObj4.img} img_mob={PageObj6.img_mob} img_mob={PageObj4.img_mob} cssClass={" col-100"} link={PageObj4.link} text={PageObj4.text} />
               <a class="show_more button" href={ getUrl() + 'Pages/NorthPage'}>
                    اقرأوا المزيد >>
                  </a>
              </div>
              <div className="ac-inner-33 ac-margin">
              <ImgAndText img={PageObj3.img} img_mob={PageObj3.img_mob} cssClass={" col-100"} link={PageObj3.link} text={PageObj3.text} />
               <a class="show_more button" href={ getUrl() + 'Pages/DeadSeaPage'}>
                    اقرأوا المزيد >>
                  </a>
              </div>
              
              <div className="ac-inner-33">
               <ImgAndText img={PageObj5.img} img_mob={PageObj5.img_mob} cssClass={" col-100"} link={PageObj5.link} text={PageObj5.text} />
               <a class="show_more button" href={ getUrl() + 'Pages/EilatNegevPage'}>
                    اقرأوا المزيد >>
                  </a>
              </div>
              <div className="ac-inner-33 show-on-mobile ac-margin">
               <ImgAndText img_mob={PageObj6.img_mob} cssClass={" col-100"} link={PageObj6.link} text={PageObj6.text} />
               <a class="show_more button" href={ getUrl() + 'Pages/thingsToDo'}>
                   اقرأوا المزيد >>
                  </a>
              </div>
              
              
              </div>
              
              <div className="clear"></div>
            </div>
          </section>
    

        <Footer />
      </div>
    )
  }

}



export default WhereToGo


// WEBPACK FOOTER //
// ./src/Pages/WhereToGo/WhereToGo.js